<template>
  <button class="button is-info" :class="{'has-tooltip-arrow has-tooltip-multiline': enabled, 'is-static is-borderless is-outlined': disabled}" :data-tooltip="tooltipText" :disabled="disabled">
    <span class="icon">
      <font-awesome-icon icon="circle-info" />
    </span>
  </button>
</template>
  
<script>
  export default {
    props: ['text', 'title'],

    computed: {
      enabled() {
        return (this.text != '' && this.text)
      },
      disabled() {
        return (this.text == '' || !this.text)
      },

      tooltipText() {
        let result = ''

        if (this.title) {
          result += this.title + "\n"
        }

        if (this.enabled) {
          result += this.text
        }

        return result
      }
    }
  }
</script>

<style scoped>
[data-tooltip]::before {
  white-space: pre-wrap !important;
}
</style>